import React from 'react';

export default class Page2 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt task">
                                    <div className="innerpadding">


                                        <div className="ilead-contentarea">
                                            <div className="border_subtitle">This tool can help</div>
                                            <p>
                                                Since that seminal study, it has been shown time and again that
                                                if managers consult staff and
                                                include them in the decision-making process, their level of
                                                engagement and individual output
                                                increases. This tool is about<span className="brown brownbold"> how to engage others to deliver</span> and
                                                will help you understand your
                                                role in recognising the qualities of individual team members,
                                                delegating tasks appropriately and
                                                engaging people to take ownership of their roles and deliver to
                                                the best of their abilities.
                                            </p>

                                            <div className="circle_title"><img
                                                src={require('@images/Browndot.png')}
                                                alt=""/>INTRODUCTION TO ENGAGING OTHERS
                                            </div>
                                            <p>Whether you’re a line manager, a project manager or have no
                                                managerial responsibilities at all, we
                                                all sometimes need to engage others to ensure we can fulfil our
                                                own responsibilities.</p>
                                            <div className="lightgreencontentbg keyquestionpad lightbgui">
                                                <div className="border_subtitle">How do you go about it?</div>
                                                <ul className="greenbullet-list ">
                                                    <li> Do you delegate to others?</li>
                                                    <li>Do you set others tasks?</li>
                                                    <li>Do you ask colleagues to pick up on things for you that
                                                        you need assistance with?
                                                    </li>
                                                    <li>When you do this, what are the results?</li>
                                                </ul>
                                            </div>
                                            <p>Most of us have asked and relied on someone to do something but
                                                been left thinking we’d have
                                                been better off doing it ourselves! </p>
                                            <p>Or, we find ourselves picking up the trail of a colleague who
                                                hasn’t done things the way we asked
                                                and find ourselves with as much work, if not more than we began
                                                with.</p>
                                            <p>Maybe, if you’ve managed a project, you gave most of the more
                                                mundane tasks to a particular
                                                individual to free up others’ time. Can you remember how that
                                                individual performed or reacted?</p>
                                            <p>Delivering high quality work is, of course, enough of a challenge
                                                without the added burden of
                                                thinking about more than monitoring people’s progress against
                                                deadlines.</p>
                                            <p>Understandable as this is, in order to get the best out of the
                                                people you work with, you need to
                                                recognise that the process of thinking and planning how to fully
                                                engage them (instead of merely
                                                instructing them) is critical to interim and eventual
                                                success.</p>
                                            <p>We’ll show you how to recognise the strengths of those you work
                                                with and how to engage, and
                                                motivate them to deliver – at all costs.</p>
                                            <div className="circle_title"><img
                                                src={require('@images/Browndot.png')}
                                                alt=""/>RECOGNISING THE STRENGTHS OF OTHERS
                                            </div>
                                            <p>As a manager, you’re accustomed to assessing people’s skills and
                                                knowledge according to
                                                particular roles, but we’ll give you a structured and more
                                                sophisticated method of considering
                                                how to optimise resources.</p>
                                            <p> This model describes a process of identifying the strengths of
                                                others. However, you don’t have to
                                                stick to it rigidly – identify or adapt those parts of it that
                                                are most helpful to you:</p>


                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page1')}
                                                    className="button-next-previous-done task">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page3')}
                                                    className="button-next-previous-done task">Next &gt;&gt;</div>
                                            </div>

                                        </div>

                                    </div>


                                </div>


                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}